import { Backdrop, CircularProgress } from '@mui/material'
import { useCallback, useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getExperimentIdByCode } from '../../api'
import { useOpenExperiment } from '../../hooks/useOpenExperiment'
import { AppStateContext } from '../../state/AppProvider'
import styles from './Experiments.module.css'

const ExperimentRedirect = () => {
  const { experimentCode } = useParams<{ experimentCode: string }>()
  const navigate = useNavigate()
  const appStateContext = useContext(AppStateContext)
  const { openExperiment } = useOpenExperiment()

  const redirectWithWarning = useCallback(
    (message: string) => {
      appStateContext?.dispatch({
        type: 'SET_SNACKBAR_STATE',
        payload: { message, severity: 'warning' },
      })
      navigate('/app/experiments')
    },
    [appStateContext, navigate],
  )

  useEffect(() => {
    if (!experimentCode) {
      navigate('/app/experiments')
      return
    }

    let cancelled = false

    getExperimentIdByCode(experimentCode)
      .then(experimentId => {
        if (cancelled) return
        if (!experimentId) {
          redirectWithWarning('Experiment not found.')
          return
        }
        return openExperiment(experimentId, true)
      })
      .then(conversation => {
        if (cancelled) return
        if (conversation === undefined) return
        if (!conversation) {
          redirectWithWarning('Experiment not found.')
        }
      })
      .catch(() => {
        if (cancelled) return
        redirectWithWarning('Failed to load experiment. Try again later.')
      })

    return () => {
      cancelled = true
    }
  }, [experimentCode, navigate, openExperiment, redirectWithWarning])

  return (
    <Backdrop
      className={styles.backdrop}
      sx={theme => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
      open>
      <div className={styles.backdropMessageContainer}>
        <CircularProgress color="inherit" />
        <p className={styles.backdropMessage}>Loading Experiment...</p>
      </div>
    </Backdrop>
  )
}

export default ExperimentRedirect
